import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { avoid } from './shared/avoid'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { audience } from './shared/audience'
import { callToAction } from './shared/callToAction'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { newsletterStyle } from './shared/newsletterStyle'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'
import { DynamicHighDetailedMail } from 'blaze-ui/icons/40'

const meta = {
  type: ChannelType.Newsletter,
  icon: DynamicHighDetailedMail,
  steps: ['Context', 'Generate Newsletter'],
  title: TextChannels[ChannelType.Newsletter].name,
  submitLabel: 'Generate Newsletter',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183789/Home%20Card%20Previews/evyharyawjck2cr8jmru.png',
}

const fields = {
  topic: topic.meta({ hide: true, generationType: meta.type }),
  newsletter_style: newsletterStyle.meta({ label: 'What style of newsletter are you looking to write?' }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  audience: audience.meta({ label: 'Who is the target audience?' }),
  language,
  include_images: includeImages.meta({
    description: 'An image will make your newsletter far more engaging and attention grabbing',
  }),
  callToAction: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const NewsletterSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const NewsletterMultiStepSchema: MultiStepSchema<ChannelType.Newsletter> = {
  steps: [
    NewsletterSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.Newsletter,
    channel: ChannelType.Newsletter,
  },
}
